import { Input } from "reactstrap";
import { useEffect, useRef } from "react";
import { useState, useContext } from "react";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { ToastContextDispatch } from "Context/CommonContext";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  id?: any;
}
export const nullOption = [{ label: "All", key: "all", value: null }];
interface DateRangeComponentIF {
  dateRanges: any;
  setDateRanges: any;
  open: boolean;
  setOpen: any;
  isChecked: boolean;
  minDate?: any;
  maxDate?: any;
}
const DateRangeComponent = ({
  dateRanges,
  setDateRanges,
  open,
  setOpen,
  isChecked,
  minDate,
  maxDate,
}: DateRangeComponentIF) => {
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { screen }: any = useWindowSize();
  const maxAllowedRangeInMilliseconds = 30 * 24 * 60 * 60 * 1000;
  const [dateUpdated, setDateUpdated] = useState<any>(false);
  const [isRangeExceeded, setIsRangeExceeded] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (dateUpdated) {
      console.log("handleFilterDate", dateRanges);
      if (!isRangeExceeded) {
        // handleFilterDate(dateRanges);
        // setIsChecked(false);
      }
    }
  }, [dateUpdated]);
  const handleRangeFocusedChange = (dateRange: any) => {
    if (dateRange[0] == 0 && dateRange[1] == 0) {
      setDateUpdated(new Date().getMilliseconds());
    }
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const dateTimeValue =
    isChecked &&
    dateRanges[0].startDate != null &&
    dateRanges[0].endDate != null
      ? `${format(dateRanges[0].startDate, "dd MMM")}`
      : dateRanges[0].startDate != null && dateRanges[0].endDate != null
      ? `${format(dateRanges[0].startDate, "dd MMM")} - ${format(
          dateRanges[0].endDate,
          "dd MMM"
        )}`
      : dateRanges[0].startDate != null && dateRanges[0].endDate == null
      ? `${format(dateRanges[0].startDate, "dd MMM")}`
      : dateRanges[0].startDate == null && dateRanges[0].endDate != null
      ? `dd MMM - ${format(dateRanges[0].endDate, "dd MMM")}`
      : "DD/MM/YYYY";
  return (
    <div ref={inputRef}>
      <Input
        onChange={(e) => {
          e.preventDefault();
        }}
        name={"dateRange"}
        id={"reactDateRange"}
        disabled={false}
        value={dateTimeValue}
        className="form-control date-input-css relative inline-flex w-full"
        placeholder={"Date"}
        onClick={() => setOpen((open: any) => !open)}
      />
      {open && (
        <>
          <DateRange
            months={1}
            rangeColors={["#00B0F5"]}
            direction="horizontal"
            className={
              ["xs", "sm", "md"].includes(screen)
                ? "calendarElementMobileView"
                : "calendarElement"
            }
            startDatePlaceholder="start date"
            endDatePlaceholder="mm/dd/yyyy"
            editableDateInputs={true}
            minDate={minDate}
            maxDate={maxDate}
            onRangeFocusChange={(DateRange) => {
              handleRangeFocusedChange(DateRange);
            }}
            onChange={(item) => {
              const { startDate, endDate } = item.selection;
              if (endDate != undefined && startDate != undefined) {
                const rangeDuration = endDate.getTime() - startDate.getTime();
                if (rangeDuration <= maxAllowedRangeInMilliseconds) {
                  const newObj = {
                    startDate: startDate,
                    endDate: endDate,
                    key: "selection",
                  };
                  const nObj = [newObj];
                  setIsRangeExceeded(false);
                  setDateRanges(() => [...nObj]);
                } else {
                  setIsRangeExceeded(true);
                  ToastDispatch({
                    isOpen: true,
                    type: "Error",
                    message:
                      "Maximum allowed range duration exceeded. (Max range is 30 days)",
                  });
                }
              }
            }}
            moveRangeOnFirstSelection={false}
            ranges={dateRanges}
          />
        </>
      )}
    </div>
  );
};
export default DateRangeComponent;
